<template>
    <el-dialog :title="dialogName" :visible.sync="dialogVisible" width="600px" :close-on-click-modal="false" :modal-append-to-body="true">
      <div class="main-box">
        <el-form ref="dataForm" id="dataForm" :model="temp" :rules="rules" label-width="160px" label-suffix="：">
          <div class="about-title">
            <div class="about-font">数勤通供应链系统</div>
            <img src="../../assets/img/home/about-bg.png"/>
          </div>
          <el-card class="box-card form-card" style="margin-top: 10px;">
            <el-row :gutter="15">
              <el-col :span="24">
                <el-form-item label="公司名称">{{orgName}}</el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="生效权益">三年权益</el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="过期时间">2025-11-12</el-form-item>
              </el-col>
            </el-row>
          </el-card>
        </el-form>

        <combo-buy ref="comboBuy" v-if="isComboBuyShow"></combo-buy>

        <combo-buy-list ref="comboBuyList" v-if="isComboBuyListShow"></combo-buy-list>

      </div>
      <div slot="footer" class="dialog-footer">
        <xr-button type="primary" @click="buy()">权益续费</xr-button>
        <xr-button type="primary" @click="historyList()">历史购买记录</xr-button>
        <xr-button type="default" @click.native="dialogVisible = false">关闭</xr-button>
      </div>
    </el-dialog>

</template>

<script>
  import ComboBuy from './Combo-Buy'
  import ComboBuyList from './combo-buy-list'

    export default {
      name: "CompanyInfo",
      data() {
        return {
          dialogName: '我的权益',
          dialogVisible: false,                                        //弹框
          isComboBuyShow: false,                                        //弹框
          isComboBuyListShow: false,                                        //弹框
          temp: {
            themeType :'',
          },
          rules: []
        }
      },
      computed: {
        orgCategory() {
          return this.$store.getters.orgCategory; //获取机构类型
        },
        orgId() {
          return this.$store.getters.orgId; //获取机构id
        },
        orgName() {
          return this.$store.getters.orgName; //获取机构名称
        },
      },
      components: {
        ComboBuy,
        ComboBuyList
      },
      methods: {
        init(){
          this.dialogVisible = true;
        },
        buy(){
          this.isComboBuyShow = true;
          this.$nextTick(()=>{
            this.$refs.comboBuy.init() //初始化页面
          })
        },
        historyList(){
          this.isComboBuyListShow = true;
          this.$nextTick(()=>{
            this.$refs.comboBuyList.init() //初始化页面
          })
        }
      }
    }
</script>

<style scoped>
  .about-title{position: relative;}
  .about-title .about-font{
    position: absolute;
    color: #fff;
    top: 33%;
    left: 26%;
    font-size: 33px;
    font-weight: 600;
  }
  .about-title img{width: 100%;}
</style>



// WEBPACK FOOTER //
// src/components/header/AboutInfo.vue